<template>
  <footer class="m-footer">
    <div class="m-footer-logo" :style="{ 'background-image': `url(${$t('footer.logo')})` }"></div>
    <div class="m-footer-content">
      <p>
        <span>{{$t('footer.company')}}</span>
        <span>{{$t('footer.caseNumber')}}</span>
      </p>
      <p>{{$t('footer.copyright')}}</p>
      <p>{{$t('footer.wangwen')}}</p>
      <p>{{$t('footer.publicSecurityRecordNumber')}}</p>
    </div>
  </footer>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
// $u: 0.01333333334;
// p {
//   margin: 0;
// }
// .m-footer {
//   width: 100%;
//   height: $u * 190rem;
//   box-sizing: border-box;
//   background-color: #000000;
//   padding: $u * 34rem 0;
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   .m-footer-logo {
//     width: $u * 120rem;
//     height: $u * 128rem;
//     // background:url("../assets/company_logo.png") center no-repeat;
//     background-repeat: no-repeat;
//     background-size: 100% 100%;
//     margin-right: $u * 46rem;
//   }

//   @media screen and (max-width: 320px) {
//     .m-footer-logo {
//       width: $u * 90rem;
//       height: $u * 106rem;
//       margin-right: $u * 8rem;
//     }
//   }

//   .m-footer-content {
//     font-size: $u * 24rem;
//     color: rgba(179, 179, 179, 1);
//     line-height: $u * 36rem;
//     text-align: left;
//     span:nth-of-type(1) {
//       margin-right: $u * 14rem;
//     }
//   }
// }
</style>
